import UnitsConverter from './src/unitsConverter.js';
import defaultConfig from './src/config/defaultConfig.js';
import acceleration from './src/quantities/acceleration.js';
import angle from './src/quantities/angle.js';
import area from './src/quantities/area.js';
import length from './src/quantities/length.js';
import mass from './src/quantities/mass.js';
import numeric from './src/quantities/numeric.js';
import rotation from './src/quantities/rotation.js';
import speed from './src/quantities/speed.js';
import time from './src/quantities/time.js';
import volume from './src/quantities/volume.js';
import temperature from './src/quantities/temperature.js';
import measurementSystem from './src/enums/system.js'
import conversionType from './src/enums/conversionType.js';
import quantityId from './src/enums/quantityId.js'; 
import FeetInchFormatter from './src/formatters/feetInchFormatter.js';
import conversionResult from './src/entities/conversionResult.js';

function getEmpty(){
    return new UnitsConverter();
}

function getPreConfigured( baseSystem, targetSystem, configOverride ){
    let defaultConf = Object.assign({}, defaultConfig);
    let converter = new UnitsConverter(Object.assign(defaultConf, configOverride || {}));
    let ftinFormatter = new FeetInchFormatter(length);
    let lengthWithFtInFormatter = Object.assign({}, length);
    if (lengthWithFtInFormatter.units.hasOwnProperty('ftin')) {
        lengthWithFtInFormatter.units.ftin.formatter = ftinFormatter;
    }

    converter.registerQuantity(acceleration);
    converter.registerQuantity(angle);
    converter.registerQuantity(area);
    converter.registerQuantity(length);
    converter.registerQuantity(mass);
    converter.registerQuantity(numeric);
    converter.registerQuantity(rotation);
    converter.registerQuantity(speed);
    converter.registerQuantity(time);
    converter.registerQuantity(volume);
    converter.registerQuantity(temperature);

    converter.baseSystem = baseSystem || measurementSystem.SI;
    converter.targetSystem = targetSystem || measurementSystem.METRIC;

    return converter;
}

export default UnitsConverter;
export {
    UnitsConverter, getEmpty, getPreConfigured,
    defaultConfig, measurementSystem, conversionType, quantityId as quantity, conversionResult
};